var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"logos"},_vm._l((_vm.logos),function(logo,index){return _c('a',{key:index,attrs:{"href":logo.url,"target":"_blank"},domProps:{"innerHTML":_vm._s(logo.svg)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }